var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 378,
    viewBox: "0 0 448 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H438C443.523 0 448 4.47715 448 10V368C448 373.523 443.523 378 438 378H9.99999C4.47714 378 0 373.523 0 368V10Z",
    fill: "#FE6A6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.113 193.798L138.513 222.598H163.489L159.889 193.798H142.113ZM133.214 179.398C131.035 179.398 129.198 181.02 128.927 183.182L122.807 232.142C122.485 234.721 124.496 236.998 127.094 236.998H174.907C177.506 236.998 179.516 234.721 179.194 232.142L173.074 183.182C172.804 181.02 170.966 179.398 168.787 179.398H133.214Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.403 235C201.403 236.104 200.507 237 199.403 237H102.602C101.497 237 100.602 236.104 100.602 235V224.599C100.602 223.495 101.497 222.599 102.602 222.599H199.403C200.507 222.599 201.403 223.495 201.403 224.599V235Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.649 65.285C246.054 66.6417 246.904 69.6914 245.547 72.0965L218.78 119.547C217.423 121.952 214.374 122.802 211.969 121.446L208.136 119.284C205.731 117.927 204.881 114.877 206.238 112.472L233.005 65.0214C234.362 62.6163 237.411 61.7664 239.816 63.1231L243.649 65.285Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.486 61.3077C177.414 59.3311 180.579 59.292 182.556 61.2204L185.706 64.2931C187.682 66.2215 187.721 69.3871 185.793 71.3636L168.796 88.7854C166.901 90.7276 166.901 93.8265 168.796 95.7687L185.793 113.19C187.721 115.167 187.682 118.333 185.706 120.261L182.556 123.334C180.579 125.262 177.414 125.223 175.486 123.246L148.678 95.7687C146.783 93.8265 146.783 90.7276 148.678 88.7854L175.486 61.3077Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.858 61.3077C272.93 59.3311 269.764 59.292 267.788 61.2204L264.638 64.2931C262.662 66.2215 262.622 69.3871 264.551 71.3636L281.548 88.7854C283.443 90.7276 283.443 93.8265 281.548 95.7687L264.551 113.19C262.622 115.167 262.662 118.333 264.638 120.261L267.788 123.334C269.764 125.262 272.93 125.223 274.858 123.246L301.666 95.7687C303.561 93.8265 303.561 90.7276 301.666 88.7854L274.858 61.3077Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.32 150.605C44.9342 150.605 43 152.539 43 154.925V189.486C43 191.872 44.9341 193.806 47.32 193.806H254.682C257.068 193.806 259.002 191.872 259.002 189.486V154.925C259.002 152.539 257.068 150.605 254.682 150.605H47.32ZM151.001 179.406C154.978 179.406 158.201 176.182 158.201 172.205C158.201 168.229 154.978 165.005 151.001 165.005C147.025 165.005 143.801 168.229 143.801 172.205C143.801 176.182 147.025 179.406 151.001 179.406Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4002 150.601V35.4002H244.602V46.5661H259.002V25.32C259.002 22.9342 257.068 21 254.682 21H47.32C44.9342 21 43 22.9341 43 25.32V160.682C43 163.067 44.9341 165.002 47.32 165.002H254.682C257.068 165.002 259.002 163.067 259.002 160.682V140.02H244.602V150.601H57.4002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopment);
export default __webpack_public_path__ + "static/media/Development.5393223971d8d8f5fe76115c1a6d4f45.svg";
export { ForwardRef as ReactComponent };